import { Drawer } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import {
  DEVICES_CREATE,
  DEVICES_EDIT,
  DEVICES_VIEW,
  DEVICE_TAB_MOBILE,
  DEVICE_TAB_TV,
} from '../../../constants/DeviceConst';
import { notificationManager } from '../../../utils/NotificationUtils';
import { allHotelsSelector, selectedHotelSelector } from '../../property/propertySlice';
import { fetchDevices } from '../configurationSlice';
import DevicesCreate from './devices-create/DevicesCreate';
import DevicesList from './devices-list/DevicesList';
import CurrrentStatusChart from './devices-status-charts/CurrentStatusChart';
import MonthlyStatusChart from './devices-status-charts/MonthlyStatusChart';
import DevicesView from './devices-view/DevicesView';
import MobileDevicesList from './mobile-devices-list/MobileDevicesList';
import './Devices.scss';

const useStyles = makeStyles((theme) => ({
  activeButton: {
    color: '#29E67C',
    borderRadius: '26px',
    border: '2px solid #74E287',
    opacity: 1,
    fontWeight: 600,
    fontSize: '1.2em',
  },
  button: {
    borderRadius: '26px',
    fontWeight: 600,
    fontSize: '1.2em',
  },
}));

const Devices = (props) => {
  const { permissions, showLoader = () => {} } = props;
  const dispatch = useDispatch();
  const classes = useStyles();

  const selectedHotel = useSelector(selectedHotelSelector);
  const allHotels = useSelector(allHotelsSelector);

  const history = useHistory();
  const [activeTab, setActiveTab] = useState(DEVICE_TAB_MOBILE);
  const [state, setState] = useState({
    type: '',
    status: false,
  });

  const [viewState, setViewState] = useState({
    type: '',
    status: false,
    obj: null,
  });
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [isFullListMode, setisFullListMode] = useState(true);
  const [devicesEndpoint, setDevicesEndpoint] = useState('');
  const [devicesWsEndpoint, setDevicesWsEndpoint] = useState('');
  const [devicesFound, setDevicesFound] = useState(false);
  const [isTvEnabled, setIsTvEnabled] = useState(false);

  const onDrawerToggle = (type, status, obj) => {
    setState({ type: type, status: status, obj: obj });
  };

  const onViewToggle = (type, status, obj) => {
    setViewState({ type: type, status: status, obj: obj });
  };

  const fetchDevicesList = useCallback(
    async (endpoint) => {
      dispatch(fetchDevices(endpoint + '/getDevices'));
    },
    [selectedHotel],
  );

  useEffect(() => {
    if (selectedHotel) {
      const selectedHotelInfo = allHotels.find((hotel) => hotel?.id === selectedHotel);
      if (selectedHotelInfo?.isDevicesEnabled) {
        setIsTvEnabled(true);
        let endpoint = selectedHotelInfo?.devicesEndpoint;
        if (endpoint) {
          endpoint = endpoint?.replace(/\/+$/, '');
          const wsEndpoint = `wss://${
            endpoint?.split('/')[2]
          }/notification/elevate/${selectedHotel}`;
          setDevicesEndpoint(endpoint);
          setDevicesWsEndpoint(wsEndpoint);
          fetchDevicesList(endpoint);
          setDevicesFound(true);
        }
      } else {
        setIsTvEnabled(false);
        setDevicesFound(false);
        setActiveTab(DEVICE_TAB_MOBILE);
      }
    }
  }, [history, selectedHotel, fetchDevicesList]);

  useEffect(() => {
    if (activeTab === DEVICE_TAB_MOBILE || activeTab === DEVICE_TAB_TV) {
      setPage(0);
      setRowsPerPage(10);
    }
  }, [activeTab]);

  const toggleDrawer = (open) => (event, reason) => {
    if (
      reason === 'backdropClick' ||
      (event?.type === 'keydown' && (event?.key === 'Tab' || event?.key === 'Shift'))
    ) {
      return;
    }
    setState(open);
  };

  const switchDrawerContent = (state) => {
    switch (state.type) {
      case DEVICES_CREATE:
        return (
          <DevicesCreate
            toggleDrawer={onDrawerToggle}
            hotelId={selectedHotel}
            category={state.obj}
            devicesEndpoint={devicesEndpoint}
            showLoader={showLoader}
          />
        );
      case DEVICES_EDIT:
        return (
          <DevicesCreate
            toggleDrawer={onDrawerToggle}
            hotelId={selectedHotel}
            category={state.obj}
            devicesEndpoint={devicesEndpoint}
            showLoader={showLoader}
          />
        );

      default:
        break;
    }
  };

  const switchViewContent = (inpState) => {
    switch (inpState.type) {
      case DEVICES_VIEW:
        return (
          <DevicesView
            device={inpState.obj}
            onViewToggle={onViewToggle}
            toggleDrawer={onDrawerToggle}
            hotelId={selectedHotel}
            permissions={permissions}
          ></DevicesView>
        );
      default:
        break;
    }
  };
  return (
    <>
      <Drawer
        anchor={'right'}
        open={state.status}
        onClose={toggleDrawer(false)}
        className='right-drawer'
      >
        {switchDrawerContent(state)}
      </Drawer>
      {viewState.status && <>{switchViewContent(viewState)}</>}
      {!viewState.status && (
        <div className='container mt-4 devices'>
          <div className='row d-flex'>
            <div className='col-md-6'>
              {/* 
              this is commented until history data available for dashboad mode
              {isFullListMode && (
                <Button
                  variant="text"
                  color="secondary"
                  size="small"
                  startIcon={<ArrowBack />}
                  onClick={(e) => {
                    setRowsPerPage(3)
                    setisFullListMode(false)
                  }}
                  className="me-2"
                >
                  Back
                </Button>
              )} */}
              <span className='page-title'>
                Devices
                {/* {isFullListMode ? "Overview" : "Devices"} */}
              </span>
            </div>
            <div className='col-md-6 d-flex justify-content-end'></div>
          </div>

          <div className='row d-flex mt-4 accommodation-list'>
            <div className='d-flex flex-wrap'>
              <Button
                size='large'
                variant={activeTab === DEVICE_TAB_MOBILE ? 'outlined' : 'text'}
                className={
                  activeTab === DEVICE_TAB_MOBILE
                    ? classes.activeButton
                    : classes.button + ' showpopup'
                }
                onClick={() => setActiveTab(DEVICE_TAB_MOBILE)}
              >
                Mobile
              </Button>
              {isTvEnabled && (
                <Button
                  size='large'
                  variant={activeTab === DEVICE_TAB_TV ? 'outlined' : 'text'}
                  className={
                    activeTab === DEVICE_TAB_TV
                      ? classes.activeButton
                      : classes.button + ' showpopup'
                  }
                  onClick={() => setActiveTab(DEVICE_TAB_TV)}
                >
                  TV
                </Button>
              )}
            </div>
          </div>

          {activeTab === DEVICE_TAB_MOBILE && (
            <div className='row mx-2 d-flex mt-4'>
              <div className='card shadow'>
                <MobileDevicesList />
              </div>
            </div>
          )}

          {activeTab === DEVICE_TAB_TV && isTvEnabled && (
            <>
              {!isFullListMode && (
                <div className='row d-flex mt-4 mx-2 '>
                  <div className='card shadow p-4 devices-dashboard'>
                    <div className='devices-dashboard-title'>Dashboard</div>
                    <div className='row mt-3'>
                      <div className='col-md-4'>
                        <div className='card shadow p-4'>
                          <div className='devices-dashboard-current-title'>
                            Current Device Status
                          </div>
                          <div className='d-flex align-items-center mt-1 devices-dashboard-current'>
                            <div className='devices-dashboard-current-count me-2'>1000</div>
                            <div className='gray-text me-2'>Devices</div>
                            <div className='devices-dashboard-current-count-prec me-1 d-flex align-items-center'>
                              <ArrowUpwardIcon fontSize='small' />5 %
                            </div>
                            <div className=' me-1'>Last mth</div>
                          </div>
                          <div className='devices-dashboard-current-chart'>
                            <CurrrentStatusChart />
                          </div>
                        </div>
                      </div>
                      <div className='col-md-8 devices-dashboard-monthly-chart'>
                        <MonthlyStatusChart />
                      </div>
                    </div>
                  </div>
                </div>
              )}

              <div className='row mx-2 d-flex mt-4'>
                <div className='card shadow'>
                  {devicesFound && devicesEndpoint && (
                    <DevicesList
                      onDrawerToggle={onDrawerToggle}
                      onViewToggle={onViewToggle}
                      permissions={permissions}
                      selectedHotel={selectedHotel}
                      state={state}
                      onsetPage={(e) => setPage(e)}
                      page={page}
                      onsetRowsPerPage={(e) => setRowsPerPage(e)}
                      rowsPerPage={rowsPerPage}
                      setisFullListMode={setisFullListMode}
                      isFullMode={isFullListMode}
                      devicesEndpoint={devicesEndpoint}
                      devicesWsEndpoint={devicesWsEndpoint}
                    />
                  )}
                </div>
              </div>
            </>
          )}
        </div>
      )}
    </>
  );
};

export default Devices;
